module.exports = __webpack_public_path__ + "png/balance1.png?e3569fea38027822210874c05e676e5a";